import React, { useEffect, useState } from 'react';
// import { appInsights, reactPlugin } from '../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import { FormControl, FormHelperText } from '@mui/material';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import MenuItem from '@mui/material/MenuItem';
import { SelectChangeEvent } from '@mui/material';

// import { createStyles, makeStyles, Theme } from "@material-ui/core/styles";
import { OptionProps, SelectProps } from './../../view-models';
import { createStyles, makeStyles, Theme } from '@material-ui/core/styles';
const selectStyles = makeStyles((theme: Theme) =>
  createStyles({
    white: {
      '& >label': {
        color: '#FFF !important',
        opacity: '0.8',
      },
      '& >div': {
        color: '#FFF !important',
        opacity: '0.8',
        '& >svg': {
          color: '#FFF !important',
          opacity: '0.8',
        },
      },
    },
  }),
);
function SelectComponent({ data, changeHandler }: SelectProps) {
  const classes = selectStyles();
  const id = data.id || 'select-' + Math.floor(Math.random() * 10000000);
  const style = data.style || { margin: 1, width: '90%' };

  const [error, setError] = useState<string>('');
  useEffect(() => {
    !!data.required && data.value === '' ? setError('Should not be empty') : setError('');
  }, [data.value]);

  return (
    <FormControl sx={style} className={data.color === 'white' ? classes.white : ''} required={data.required}>
      <InputLabel id={id}>{data.label}</InputLabel>
      <Select
        labelId={id}
        disabled={data.disabled || false}
        value={data.value}
        size="small"
        onChange={(e: SelectChangeEvent<string>) => changeHandler(e)}
        autoWidth
        label={data.label}
        error={data?.error || !!error}
      >
        {data.options.map((el: OptionProps) => (
          <MenuItem key={el.value} value={el.value} disabled={el.hasOwnProperty('disabled') ? el.disabled : false}>
            {el.label}
          </MenuItem>
        ))}
      </Select>
      <FormHelperText sx={{ color: 'red' }}>{data?.helperText || error}</FormHelperText>
    </FormControl>
  );
}

// export default withAITracking(reactPlugin, SelectComponent);
export default SelectComponent;
